import './ProgramPage.css'

import React from 'react'
import { withProps } from 'recompose'
import Markdown from 'react-markdown'

import { getTracks, getWorkshopsContent } from '../app/selectors'
import ScheduleTable from './ScheduleTable'
import content from '../content'
import { isTrackWorkshop } from '../app/predicates'

const WorkshopsPage = ({ text, tracks }) => {
  return (
    <div>
      <Markdown source={text} />
      <ScheduleTable tracks={tracks} programContent={programContent} />
    </div>
  )
}

const tracks = getTracks(content).filter(isTrackWorkshop)
const programContent = getWorkshopsContent(content)

const withPageContent = withProps({
  text: programContent.text,
  tracks,
})

export default withPageContent(WorkshopsPage)



// WEBPACK FOOTER //
// ./src/containers/WorkshopsPage.js